import { Button, Sheet } from "@c4c-web/ui";
import React, { useEffect, useState } from "react";
// import { useAnalytics } from "@c4c-web/core/hooks/analytics";
// import {
//   EAnalyticsEvent,
//   EAnalyticsEventAction,
//   EAnalyticsEventCategory,
// } from "@c4c-web/core/constants";
import { AddressList } from "../AddressList";
import { EAddressStatus } from "../../../constants/address.constants";
import { AddressMap } from "../MapSheet";
import {
  // EAnalyticsEventLabel,
  // EAnalyticsScreenName,
  POS_INFO,
} from "../../../constants";
import {
  // getDefaultAddressAnalyticsParams,
  rearrangeAddresses,
  setCookie,
  setLatLong,
  setLocalSelectedAddressId,
} from "../../../utils";
import type { IDeliveryLocationSheetProps } from "./delivery-location-sheet.interface";
import { GenerateAddressOptions } from "./GenerateAddressOptions";

export const DeliveryLocationSheet: React.FC<IDeliveryLocationSheetProps> = ({
  addresses,
  configStore,
  currentAddress,
  open,
  onOpenChange,
  onUpdateUnverifiedAddress,
  storeId,
  t,
  showMap,
  toggleMap,
}): JSX.Element => {
  // const { sendEvent } = useAnalytics();

  const [selectedAddress, setSelectedAddress] =
    useState<string>(currentAddress);

  useEffect(() => {
    setSelectedAddress(currentAddress);
  }, [currentAddress]);

  const options = GenerateAddressOptions(
    rearrangeAddresses(addresses, selectedAddress),
  );

  const handleClick = (): void => {
    onOpenChange(false);
    toggleMap(!showMap);
  };

  const handleAddressChange = (addressId: string): void => {
    const selectedOption = options.find((option) => option.value === addressId);
    const currentSelectedAddress = addresses.find(
      (address) => address.id === addressId,
    );
    setSelectedAddress(addressId);
    // sendEvent(
    //   {
    //     event: EAnalyticsEvent.Custom,
    //     event_action: EAnalyticsEventAction.AddressJourney,
    //     event_category: EAnalyticsEventCategory.UserEngagement,
    //     event_label: EAnalyticsEventLabel.SavedAddressSelected,
    //   },
    //   getDefaultAddressAnalyticsParams(EAnalyticsScreenName.MyAddresses),
    // );
    if (
      selectedOption &&
      selectedOption.status.toLowerCase() !==
        EAddressStatus.UNVERIFIED.toString()
    ) {
      setLocalSelectedAddressId(addressId);
      setCookie(POS_INFO, "");
      setLatLong(
        currentSelectedAddress?.latitude as unknown as string,
        currentSelectedAddress?.longitude as unknown as string,
      );
      window.location.reload();
    }
  };

  const footer = (
    <Button
      className="w-full"
      onClick={handleClick}
      size="lg"
      variant="secondary"
    >
      {t("addressJourney.addNewDeliveryAddress")}
    </Button>
  );

  return (
    <>
      <Sheet
        className="max-h-screen md:h-full md:w-[480px]"
        footer={footer}
        hideScrollBar
        id="delivery-location-sheet"
        isTitleBorder={false}
        onOpenChange={onOpenChange}
        open={open}
        subtitle={t("addressJourney.savedAddresses", {
          totalAddresses: options.length,
        })}
        title={t("addressJourney.chooseDeliveryLocation")}
      >
        <AddressList
          closeDrawer={onOpenChange}
          onSelect={handleAddressChange}
          onUpdateUnverifiedAddress={onUpdateUnverifiedAddress}
          options={options}
          selectedValue={selectedAddress}
          t={t}
        />
      </Sheet>

      <AddressMap
        configStore={configStore}
        open={showMap}
        setShowMap={toggleMap}
        storeId={storeId}
        t={t}
      />
    </>
  );
};
